module.exports = __webpack_public_path__ + "static/media/teleMadrid.52637b4f.png";